// extracted by mini-css-extract-plugin
export default {"hasBorderTop":"hasBorderTop---d6NOw","hasPaddings":"hasPaddings---YvdHb"};